var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.audioUrl)?_c('div',{staticClass:"audio-player-container"},[_c('audio',{ref:"audioPlayer",staticClass:"audio-element",attrs:{"src":_vm.audioUrl,"controls":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }